<div id="root" class="desktop">
    <div class="header"></div>
    <div class="main"></div>
    <div class="overlay"></div>
</div>